import React from 'react';
import LogoBlanco from '../../assets/logoBlanco.png';
import Whatsapp from '../../assets/whatsapp.svg';
import Instagram from '../../assets/instagram.svg';
import { siteConfig } from '../../config/site';

export function AmbFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-brand-navy py-10 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-8 md:grid-cols-3">
          <div className="text-center md:text-left">
            <img src={LogoBlanco} alt="SpecifiC" className="mx-auto h-10 md:mx-0" />
          </div>

          <div className="flex justify-center gap-3">
            <a href={siteConfig.social.whatsapp} target="_blank" rel="noopener noreferrer" className="rounded-full bg-white/10 p-3 hover:bg-brand-accent" aria-label="WhatsApp">
              <img src={Whatsapp} alt="" className="h-5 w-5" />
            </a>
            <a href={siteConfig.social.instagram} target="_blank" rel="noopener noreferrer" className="rounded-full bg-white/10 p-3 hover:bg-brand-accent" aria-label="Instagram">
              <img src={Instagram} alt="" className="h-5 w-5" />
            </a>
          </div>

          <div className="text-center text-sm text-white/70 md:text-right">
            <a href={siteConfig.urls.demo} className="hover:text-brand-accent">ventas@specific-ag.com</a>
            <p className="mt-1">SpecifiC ® - {year}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
